import { DisplayType } from '@nkr/enums/display-type';
import { refreshIntervals } from './models';
import { Button, FormControl, Glyphicon, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FormControlWrapper } from '../swap-management/swaps/styles';

interface IProps {
    display: DisplayType,
    autoRefresh: number,
    filter: number,
    expandSwapList: boolean,
    onDisplayChange: (display: number) => void,
    onAutoRefreshChange: (autoRefresh: number) => void,
    onRefresh: () => void,
    onFilterChange: (filter: number) => void,
    onExpand: () => void
}

const Toolbar = (props: IProps) => {
    return (
        <div style={{ flexBasis: '70%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 15 }}>
                    <div style={{ marginRight: 5, fontSize: 12 }}>Show:</div>
                    <div style={{ marginRight: 10 }}>
                        <FormControlWrapper
                            value={props.display}
                            componentClass='select'
                            style={{ fontSize: 12 }}
                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => props.onDisplayChange(parseInt(e.currentTarget.value))}
                        >
                            <option value='1'>Menus</option>
                            <option value='4'>No Menus</option>
                        </FormControlWrapper>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 15 }}>
                    <div style={{ marginRight: 5, fontSize: 12 }}>Auto refresh:</div>
                    <div style={{ marginRight: 5 }}>
                        <FormControlWrapper
                            value={props.autoRefresh}
                            componentClass='select'
                            style={{ fontSize: 12 }}
                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => props.onAutoRefreshChange(parseInt(e.currentTarget.value))}
                        >
                            {refreshIntervals.map((interval, index) =>
                                <option key={index} value={interval.value}>{interval.label}</option>
                            )}
                        </FormControlWrapper>
                    </div>
                    <div>
                        <Glyphicon glyph='refresh' title='Refresh now' onClick={props.onRefresh} />
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 15 }}>
                    <div style={{ marginRight: 5, fontSize: 12 }}>Swaps:</div>
                    <div>
                        <ToggleButtonGroup type='radio' name='swaps' value={props.filter}>
                            <ToggleButton type='radio' value={0} className={props.filter == 0 ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onFilterChange(0)}>All&nbsp;</ToggleButton>
                            <ToggleButton type='radio' value={1} className={props.filter == 1 ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onFilterChange(1)}>In-process</ToggleButton>
                            <ToggleButton type='radio' value={2} className={props.filter == 2 ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onFilterChange(2)}>Scheduled</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                </div>

                <div>
                    <Button bsSize='xs' onClick={props.onExpand}><Glyphicon glyph={props.expandSwapList ? 'chevron-down' : 'chevron-up'} /></Button>
                </div>
            </div>
        </div>
    );
}

export default Toolbar;